import React, { Component } from 'react';
import { FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import Select from 'react-select';
import { TAGS } from './helpers/tagsHelper';
import { isMine, amPremium } from './helpers/fireHelper';

class Options extends Component {
  constructor(props) {
    super(props)
    this.state = {
      description: '',
      name: '',
      tags: [],
      tagOptions: TAGS,
      premium: false
    }
    this.handleNameChange = this.handleNameChange.bind(this)
    this.handleDescriptionChange = this.handleDescriptionChange.bind(this)
    this.handleSelectChange = this.handleSelectChange.bind(this)
  }
  componentWillReceiveProps(nextProps) {
    this.setState({
      name: nextProps.name,
      description: nextProps.description,
      tags: nextProps.tags
    })
    if (nextProps.user) {
      amPremium().then(r => {
        if (typeof r.premium !== "undefined") {
          this.setState({ premium: r.premium })
        }
      })
    }
  }

  handleNameChange(e) {
    this.setState({ name: e.target.value });
    this.props.optionsChange('name', e.target.value);
  }

  handleSelectChange (tags) {
    this.props.optionsChange('tags', tags)
  }

  handleDescriptionChange(e) {
    this.setState({ description: e.target.value });
    this.props.optionsChange('description', e.target.value);
  }

  render() {
    const buttonStyle = { backgroundColor: "#f76636", color: "white",
                          border: "none", borderRadius: "3px", margin: "5px" };
    const buttonGreen = { backgroundColor: "#26C281", color: "white",
                          border: "none", borderRadius: "3px", margin: "5px" };
    // const buttonRed   = { backgroundColor: "red", color: "white",
    //                       border: "none", borderRadius: "3px", margin: "5px" };

    // <button style={buttonRed} onClick={this.props.createWithPostOffice}>  Create with Post Office</button>
    // <button style={buttonRed} onClick={this.props.updateWithPostOffice}>  Update with Post Office</button>
    // <button style={buttonRed} onClick={this.props.forkWithPostOffice}>    Fork with Post Office</button>
    // <button style={buttonRed} onClick={this.props.deleteWithPostOffice}>  Delete with Post Office</button>
    // <button style={buttonRed} onClick={this.props.createWithPostOffice}>To Post Office</button>
    // console.log(this.props.justUpdated)
    // console.log('PROPS', this.props)
    // if (typeof this.props.authorId !== "undefined")
    // console.log('PREMIUM:', this.state.premium)

    return (
      <div className='options-settings'>

        <h5>OPTIONS</h5>
        <FormGroup controlId="formBasicText">
          <br />
          <ControlLabel>Name</ControlLabel>
          <FormControl type="text" value={this.state.name} placeholder="Enter text"
            onChange={this.handleNameChange} />
          <br />
          <ControlLabel>Description</ControlLabel>

          <FormControl componentClass="textarea" placeholder="textarea"
            value={this.state.description}
            onChange={this.handleDescriptionChange} />
          <br />
          <ControlLabel>Tags</ControlLabel>
          <Select
            multi
            value={this.state.tags}
            placeholder="Add some tags"
            options={this.state.tagOptions}
            onChange={this.handleSelectChange}
            onFocus={this.focusHandler}
          />
          <br />
          </FormGroup>

          {this.props.isNew
            ?
            <div>
              <button style={this.props.justUpdated === "create" ? buttonGreen : buttonStyle }
                      onClick={this.props.createWithPostOffice}>
                      {this.props.justUpdated === "create" ? "Saved 😃 " : "Save Envelope"}
                      </button>
              {this.state.premium ?
                <button style={this.props.justUpdated === "create" ? buttonGreen : buttonStyle }
                        onClick={this.props.createPrivatelyWithPostOffice}>
                        {this.props.justUpdated === "create" ? "Saved 😃 " : "Privately Save Envelope"}
                        </button>
                        : null
              }

            </div>
            :
            isMine(this.props.authorId)
            ?
            <div>
              <button style={this.props.justUpdated === "fork" ? buttonGreen : buttonStyle }
                      onClick={this.props.forkWithPostOffice}>
                      {this.props.justUpdated === "fork" ? "Forked 😃 " : "Fork Envelope" }
                      </button>
              <button style={this.props.justUpdated === "update" ? buttonGreen : buttonStyle }
                      onClick={this.props.updateWithPostOffice}>
                      {this.props.justUpdated === "update" ? "Updated 😃 " : "Update Envelope" }
                      </button>
              {this.state.premium ?
                <button style={this.props.justUpdated === "update" ? buttonGreen : buttonStyle }
                        onClick={this.props.updatePrivatelyWithPostOffice}>
                        {this.props.justUpdated === "update" ? "Updated 😃 " : "Update Envelope Privately" }
                        </button>
                        : null
              }


              <button style={buttonGreen}
                      onClick={this.props.hostWithPostOffice}>HOST</button>
            </div>
            :
            <div>
              <button style={this.props.justUpdated === "fork" ? buttonGreen : buttonStyle }
                      onClick={this.props.forkWithPostOffice}>
                      {this.props.justUpdated === "fork" ? "Forked 😃 " : "Fork Envelope" }
                      </button>
            </div>

          }



        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
        <br/>
      </div>
    )
  }
}

export default Options;



// WEBPACK FOOTER //
// ./src/Options.js